// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"193":"7254049c","223":"f98faaaf"}[chunkId] + ".chunk.js");